<div class="glassy-bg card-nav-tabs mt-0 rounded-lg border-0 shadow-lg">
<div class="collapse show">
    <div class="card-body">
    <div class="compliance-monitoring-program-accordion border-0 rounded-lg">
        
        <div class="mb-3">
        <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
            <div class="compliance-monitoring-icon-bg-primary me-2">
                <i class="bi bi-folder-fill"></i>
            </div>
            <p class="mb-0 text-xs fw-bold">{{ form_name || 'Questionnaire Responses' }}</p>
            </div>
        </div>
        </div>

        <!-- Content - Always Visible -->
        <div class="compliance-monitoring-projects-wrapper">
        <div class="compliance-monitoring-project-accordion border-0 rounded-lg mb-3">
            
            <!-- Answers Content -->
            <div class="compliance-monitoring-project-details p-2 mt-2">
            <div>
                <!-- Loading State -->
                <div v-if="loading_form" class="text-center py-4">
                <div class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
                <p class="text-xs text-muted mt-2">Loading questionnaire...</p>
                </div>

                <!-- Form Data -->
                <template v-else-if="sections.length > 0">
                <div v-for="(section, sIdx) in sections" :key="`section-${sIdx}`" class="mb-3 mt-4">
                    <div class="glassy-table border-0 border-1 rounded-lg mb-2 p-3 shadow">
                    <!-- Section header -->
                    <div 
                        class="section-header text-x fw-bold d-flex justify-content-between align-items-center border-bottom border-2 pb-3"
                        @click="toggle_section(sIdx)"
                        style="cursor: pointer;"
                    >
                        <!-- Left side -->
                        <div class="d-flex align-items-center gap-2 flex-shrink-0">
                        <span class="text-capitalize">{{ section.name || `Section ${sIdx + 1}` }}</span>
                        </div>

                        <!-- Right side -->
                        <div class="d-flex align-items-center gap-2">
                        <i :class="is_section_open(sIdx) ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                        </div>
                    </div>

                    <!-- Fields/Questions -->
                    <div class="mt-1" v-if="is_section_open(sIdx)">
                        <template v-for="(question, qIdx) in section.questions" :key="`question-${sIdx}-${qIdx}`">
                        
                        <!-- Main Question Container -->
                        <div class="d-flex justify-content-between align-items-start mt-1">
                            <div class="d-flex flex-grow-1">
                            <span class="text-xs fw-7 me-1">{{ qIdx + 1 }}.</span>
                            <label class="flex-grow-1 text-dark text-xs text-capitalize fw-7">
                                {{ question.question_text }}
                            </label>
                            </div>
                        </div>

                        <!-- Main Question Answer -->
                        <div class="mb-3 ms-2">
                            <!-- Short Text / Date -->
                            <template v-if="get_question_input_type(question.question_type) === 'text' || get_question_input_type(question.question_type) === 'date'">
                            <input
                                :type="get_question_input_type(question.question_type)"
                                class="form-control form-control-sm text-xxs bg-white border py-1 rounded-lg"
                                :id="`question_${question.id}`"
                                :value="question.answer"
                                :placeholder="'No Answer'"
                                readonly
                            />
                            </template>

                            <!-- Long Text / Textarea -->
                            <template v-else-if="get_question_input_type(question.question_type) === 'textarea'">
                            <textarea
                                :id="`question_${question.id}`"
                                class="form-control form-control-sm text-xxs bg-white border py-1 rounded-lg"
                                rows="3"
                                :placeholder="'No Answer'"
                                readonly
                            >{{ question.answer }}</textarea>
                            </template>

                            <!-- Radio Group (Single Select) -->
                            <div v-else-if="get_question_input_type(question.question_type) === 'radio'" class="radio-group">
                            <div 
                                v-for="choice in question.multi_select_choices" 
                                :key="choice.id"
                                class="form-check"
                            >
                                <input 
                                class="form-check-input" 
                                type="radio" 
                                :name="`question_${question.id}`" 
                                :id="`choice_${choice.id}`"
                                :checked="question.answer === choice.choice"
                                disabled
                                >
                                <label class="form-check-label text-xxs" :for="`choice_${choice.id}`">
                                {{ choice.choice }}
                                </label>
                            </div>
                            </div>

                            <!-- Checkbox Group (Multi Select) -->
                            <div v-else-if="get_question_input_type(question.question_type) === 'checkbox'">
                            <div 
                                v-for="choice in question.multi_select_choices" 
                                :key="choice.id"
                                class="form-check"
                            >
                                <input 
                                class="form-check-input" 
                                type="checkbox" 
                                :id="`choice_${choice.id}`"
                                :checked="question.answer && question.answer.includes(choice.choice)"
                                disabled
                                >
                                <label class="form-check-label text-xxs" :for="`choice_${choice.id}`">
                                {{ choice.choice }}
                                </label>
                            </div>
                            </div>
                        </div>
                        </template>
                    </div>
                    </div>
                </div>
                </template>

                <!-- No Data State -->
                <div v-else class="text-center py-4">
                <i class="bi bi-inbox fs-1 text-muted"></i>
                <p class="text-muted mt-2 mb-0 text-xs">
                    No questionnaire data available.
                </p>
                </div>
            </div>
            </div>
        </div>

        <!-- Verification Section (Hidden) -->
        <div class="compliance-monitoring-project-accordion border table-border-color rounded-lg d-none">
            <div class="compliance-monitoring-project-header">
            <div class="compliance-monitoring-project-connector"></div>
            <div class="d-flex align-items-center">
                <i class="bi bi-chevron-down"></i>
                <div class="compliance-monitoring-icon-bg-jade ms-2">
                <i class="bi bi-shield-check"></i>
                </div>
                <div class="ms-3">
                <p class="mb-0 text-xs">Verification</p>
                <p class="mb-0 text-xxs text-muted">{{ verification_results.length }} services available</p>
                </div>
            </div>
            </div>

            <!-- Verification Service Cards -->
            <div class="compliance-monitoring-project-details">
            <div class="row g-3">
                <div 
                class="col-md-12" 
                v-for="(service, index) in verification_results" 
                :key="index"
                >
                <div 
                    class="service-card card h-100 shadow-sm"
                    :class="get_servicecard_class(service.status)"
                >
                    <div class="card-header bg-transparent border-0 pb-0">
                    <div class="d-flex justify-content-between align-items-start">
                        <div class="d-flex align-items-center">
                        <div class="compliance-monitoring-icon-bg-jade me-2">
                            <i class="bi" :class="get_service_icon(service.type)"></i>
                        </div>
                        <div>
                            <h6 class="mb-0 text-xs fw-bold">{{ service.label }}</h6>
                            <small class="text-muted text-xxs">{{ service.date }}</small>
                        </div>
                        </div>
                        <span class="badge bg-light text-dark border text-xxs">
                        {{ service.status }}
                        </span>
                    </div>
                    </div>
                    
                    <div class="card-body pt-2">
                    <button 
                        class="btn btn-outline-secondary btn-sm w-100 text-xxs mb-2"
                        @click="toggle_service_details(index)"
                    >
                        <i class="bi" :class="expanded_service === index ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                        {{ expanded_service === index ? 'Hide Details' : 'View Details' }}
                    </button>
                    
                    <!-- Service Details -->
                    <div v-if="expanded_service === index" class="mt-3">
                        <div class="bg-light rounded p-2">
                        <div 
                            v-for="(val, key) in service.details" 
                            :key="key"
                            class="d-flex justify-content-between align-items-center py-1"
                        >
                            <small class="text-muted">{{ format_key(key) }}:</small>
                            <small class="fw-semibold">
                            <template v-if="Array.isArray(val)">{{ val.join(', ') }}</template>
                            <template v-else-if="typeof val === 'boolean'">{{ val ? 'Yes' : 'No' }}</template>
                            <template v-else>{{ val }}</template>
                            </small>
                        </div>
                        </div>
                        
                        <div class="mt-2 d-flex gap-1">
                        <button class="btn btn-success btn-sm text-xxs flex-fill" v-if="service.status === 'Pending'">
                            <i class="bi bi-check-circle me-1"></i>Approve
                        </button>
                        <button class="btn btn-outline-primary btn-sm text-xxs flex-fill">
                            <i class="bi bi-arrow-clockwise me-1"></i>Retry
                        </button>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        </div>
    </div>
    </div>
</div>
</div>

<!-- Modal -->
<teleport to="body">
<div
  class="modal fade"
  id="verification_results_modal"
  ref="verification_results"
  tabindex="-1"
  aria-labelledby="verification_results_label"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="verification_results_label">Verification services for Trust Compliance</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p class="fw-bold text-x">Select Services</p>

        <div class="container">
          <div class="row">
            <div class="col-md-6 mb-3" v-for="(service, index) in verification_services" :key="index">
              <div class="d-flex justify-content-between align-items-center border rounded p-3 shadow-sm bg-light">
                <div>
                  <p class="mb-1 text-xxs fw-bold">{{ service.name }}</p>
                  <small class="text-muted text-xxs">{{ service.description }}</small>
                </div>
                <label class="text-xxs">
                  <input type="checkbox" v-model="service.selected" class="form-check-input">
                </label>
              </div>
            </div>

          </div>
          <div class="d-flex justify-content-end gap-2 mt-2 text-xxs">
            <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="auto_verification">
              Start verification
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
</teleport>